import { service } from '../../../../helpers/http' 

export const ActionGetWorkTimeDates = ({ dispatch }, payload) => { 
    return service({
        module: 'domainWorkTimeDate',
        action: 'getWorkTimeDates',
        payload: payload
    })
}

export const ActionPostWorkTimeDates = ({ dispatch }, payload) => {

    return service({
        module: 'domainWorkTimeDate',
        action: 'postWorkTimeDates',
        payload: payload
    })
    
}

export const ActionPutWorkTimeDates = ({ dispatch }, payload) => {

    return service({
        module: 'domainWorkTimeDate',
        action: 'putWorkTimeDates',
        payload: payload
    })
    
}

export const ActionDeleteWorkTimeDates = ({ dispatch }, payload) => {

    return service({
        module: 'domainWorkTimeDate',
        action: 'deleteWorkTimeDates',
        payload: payload
    })
    
}
